import React from 'react';
import { observer } from 'mobx-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useStore } from '../store/useStore';

export default observer(function AuthRoute({ children }: { children: JSX.Element }) {
  const { loginStore } = useStore();
  const location = useLocation();
  const hasLogin = loginStore.data.hasLogin;

  if (hasLogin) {
    return children;
  } else {
    return <Navigate to='/creator/login' state={{ from: location }} replace />;
  }
});
